<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="$t('views.machine.form.name')" prop="name" >
        <a-input v-model="form.name" :placeholder="$t('views.machine.form.namePlaceholder')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.machine.form.machineMeter')" prop="machineMeter" >
        <a-input-number v-model="form.machineMeter" style="width: 100%;" :min="0" :step="0.01" :precision="2" :placeholder="$t('views.machine.form.machineMeterPlaceholder')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.machine.form.doubleMeter')" prop="doubleMeter" >
        <a-input-number v-model="form.doubleMeter" style="width: 100%;" :min="0" :step="0.01" :precision="2" :placeholder="$t('views.machine.form.doubleMeterPlaceholder')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.machine.form.bottomMeter')" prop="bottomMeter" >
        <a-input-number v-model="form.bottomMeter" style="width: 100%;" :min="0" :step="0.01" :precision="2" :placeholder="$t('views.machine.form.bottomMeterPlaceholder')" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('views.machine.form.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('views.machine.form.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getMachine, addMachine, updateMachine } from '@/api/user/machine'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      form: {
        id: null,
        name: null,
        machineMeter: null,
        doubleMeter: null,
        bottomMeter: null,
        sort: null,
        status: 1,
        createTime: null,
        remark: null
      },
      formType: 1,
      open: false
    }
  },
  computed: {
    rules () {
      return {
        name: [
          { required: true, message: this.$t('views.machine.rule.nameRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    '$i18n.locale' () {
      if (!this.open) return
      this.formTitle = this.formType === 2 ? this.$t('views.machine.title.edit') : this.$t('views.machine.title.add')
    }
  },
  methods: {
    onClose () {
      this.open = false
    },
    cancel () {
      this.open = false
      this.reset()
    },
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        name: null,
        machineMeter: null,
        doubleMeter: null,
        bottomMeter: null,
        sort: null,
        status: 1,
        createTime: null,
        remark: null
      }
    },
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('views.machine.title.add')
    },
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getMachine({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('views.machine.title.edit')
      })
    },
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateMachine(this.form).then(response => {
              if(response.success) {
                this.$message.success(this.$t('views.machine.msg.updateOk'),3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || this.$t('views.machine.msg.updateFail')
                this.$message.error(messageInfo)
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addMachine(this.form).then(response => {
              if(response.success) {
                this.$message.success(this.$t('views.machine.msg.addOk'),3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || this.$t('views.machine.msg.addFail')
                this.$message.error(messageInfo)
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
